import { valueSetDb } from './valueset-db.js';

export const valueSetJson = valueSetDb;